export default __webpack_public_path__ + "static/comfort-f54aa1e0e412d4e094a7982d739951e1.jpg";